import { useEffect, useState } from "react";
import { KiteMark } from "@/components/Logo";
import api from "@/lib/api";
import Navbar from "@/sections/Navbar";
import Hero from "@/sections/Hero";
import Marquee from "@/sections/Marquee";
import About from "@/sections/About";
import VisionMission from "@/sections/VisionMission";
import Gallery from "@/sections/Gallery";
import TeamCollection from "@/sections/TeamCollection";
import Reels from "@/sections/Reels";
import Blog from "@/sections/Blog";
import Contact from "@/sections/Contact";
import Footer from "@/sections/Footer";

const Home = () => {
  const [content, setContent] = useState(null);
  const [gallery, setGallery] = useState([]);
  const [reels, setReels] = useState([]);
  const [team, setTeam] = useState([]);
  const [blog, setBlog] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    let live = true;
    Promise.all([api.get("/content"), api.get("/gallery"), api.get("/reels"), api.get("/team"), api.get("/blog")])
      .then(([c, g, r, t, b]) => {
        if (!live) return;
        setContent(c.data);
        setGallery(g.data);
        setReels(r.data);
        setTeam(t.data);
        setBlog(b.data);
      })
      .catch(() => live && setError("Could not reach the sky. Please refresh in a moment."));
    return () => {
      live = false;
    };
  }, []);

  if (error) {
    return (
      <div className="min-h-screen grid place-items-center bg-paper font-body text-navy text-center px-6" data-testid="home-error">
        <div>
          <KiteMark className="w-14 h-14 mx-auto mb-4" />
          <p className="font-display text-2xl">{error}</p>
        </div>
      </div>
    );
  }

  if (!content) {
    return (
      <div className="min-h-screen grid place-items-center bg-paper" data-testid="home-loading">
        <div className="text-center">
          <div className="animate-kite-bob inline-block" style={{ "--r": "-8deg" }}>
            <KiteMark className="w-16 h-16" />
          </div>
          <p className="mt-4 font-script text-2xl text-navy/70">Catching the wind…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-paper font-body text-ink antialiased" data-testid="home-page">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <Hero content={content} />
      <Marquee content={content} />
      <About content={content} />
      <VisionMission content={content} />
      <Gallery content={content} images={gallery} />
      <TeamCollection content={content} members={team} />
      <Reels content={content} reels={reels} />
      <Blog content={content} posts={blog} />
      <Contact content={content} />
      <Footer content={content} />
    </div>
  );
};

export default Home;
